import React from 'react';

import { Input } from 'antd';

/**
 * A Grid field: named rows down the side, named columns across the top.
 *
 * On a phone it is stacked a row at a time — each row is a block headed by its own
 * name, with that row's columns listed underneath — because that is how it is
 * filled in: one item, then everything about it. Nothing scrolls sideways and
 * nothing is hidden behind a control.
 *
 * Value shape is the same as the API's: { r1: { c1: 'text' } }.
 */
const GridField = ({ columns = [], rows = [], value, onChange }) => {
  const readCell = (rowKey, columnKey) => value?.[rowKey]?.[columnKey] ?? '';

  const writeCell = (rowKey, columnKey, text) => {
    const current = value ?? {};
    onChange?.({ ...current, [rowKey]: { ...current[rowKey], [columnKey]: text } });
  };

  if (columns.length === 0 || rows.length === 0) return null;

  return (
    <div className="document-fill__grid">
      {rows.map((row) => (
        <div className="document-fill__grid-block" key={row.key}>
          <div className="document-fill__grid-blockhead">{row.label}</div>

          <div className="document-fill__grid-table">
            {columns.map((column) => (
              <React.Fragment key={column.key}>
                <div className="document-fill__grid-rowhead">{column.label}</div>
                <div className="document-fill__grid-cellbox">
                  <Input
                    className="customField-Inputs"
                    value={readCell(row.key, column.key)}
                    onChange={(event) => writeCell(row.key, column.key, event.target.value)}
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GridField;
